<template>
  <div
    v-if="chartComponent"
    class="fill-height"
  >
    <component
      :is="chartComponent"
      :periods="periods"
      :chart="chart"
      :loading="loading"
      :removable="removable"
      @remove="$emit('remove')"
    />
  </div>
</template>

<script>
import TotalDistancePeriodChart from '@/components/charts/implementation/period/TotalDistancePeriodChart.vue'
import HighSpeedRunningPeriodChart from '@/components/charts/implementation/period/HighSpeedRunningPeriodChart.vue'
import VolumeIntensityPeriodChart from '@/components/charts/implementation/period/VolumeIntensityPeriodChart.vue'
import MaxVelocityPeriodChart from '@/components/charts/implementation/period/MaxVelocityPeriodChart.vue'
import AccelerationsDecelerationsPeriodChart from '@/components/charts/implementation/period/AccelerationsDecelerationsPeriodChart.vue'
import SpeedZonePeriodChart from '@/components/charts/implementation/period/SpeedZonePeriodChart.vue'
import VolumeIntensityScatterPeriodChart from '@/components/charts/implementation/period/VolumeIntensityScatterPeriodChart.vue'
import MaxAvgHeartRatePeriodChart from '@/components/charts/implementation/period/MaxAvgHeartRatePeriodChart.vue'
import TrimpMinPeriodChart from '@/components/charts/implementation/period/TrimpMinPeriodChart.vue'
import HrZonePeriodChart from '@/components/charts/implementation/period/HrZonePeriodChart.vue'

export default {
  name: 'PerformancePeriodChart',
  components: {
    TotalDistancePeriodChart,
    HighSpeedRunningPeriodChart,
    VolumeIntensityPeriodChart,
    MaxVelocityPeriodChart,
    AccelerationsDecelerationsPeriodChart,
    SpeedZonePeriodChart,
    VolumeIntensityScatterPeriodChart,
    MaxAvgHeartRatePeriodChart,
    TrimpMinPeriodChart,
    HrZonePeriodChart
  },
  props: {
    periods: {
      type: Array,
      default: () => []
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartComponent() {
      const componentMap = {
        TDIST_MMIN: 'TotalDistancePeriodChart',
        HSR_EFF: 'HighSpeedRunningPeriodChart',
        VOL_INT: 'VolumeIntensityPeriodChart',
        MAXVEL_ALL: 'MaxVelocityPeriodChart',
        ACC_DEC: 'AccelerationsDecelerationsPeriodChart',
        SPD_ZONE: 'SpeedZonePeriodChart',
        VOL_INT_SCAT: 'VolumeIntensityScatterPeriodChart',
        VOL_DIST: 'VolumeDistributionPeriodChart',
        INTS_DIST: 'IntensityDistributionPeriodChart',
        MAXHR_AVGHR: 'MaxAvgHeartRatePeriodChart',
        TRIMP_MIN: 'TrimpMinPeriodChart',
        HR_ZONE: 'HrZonePeriodChart'
      }

      return componentMap[this.chart.key] || null
    }
  }
}
</script>
